<template>
    <div>
        <!-- <h6 class="heading-small text-muted mb-4">Order Items</h6> -->
        <b-overlay :show="loading" rounded="sm">
            <b-modal no-close-on-backdrop ref="importModal" @ok="importItems" @cancel="clearItems" body-class="p-0" centered
                header-class="p-0" accordion footer-class="d-flex justify-content-center border-0"
                content-class="custom-model-wrap" size="lg">
                <template #modal-header="{ cancel }">
                    <div class="title-block text-center p-2">{{ modalTitle }}</div>
                    <button type="button" @click="cancel()" aria-label="Close" class="close">
                        ×
                    </button>
                </template>
                <b-card no-body>
                    <b-card-body class="p-0 manage-order-item-popup">
                        <div>
                            <h6 class="text-center mb-2 col-12" v-if="template_primary_items.length > 0 &&
                                template_secondary_items.length > 0
                                ">
                                <strong> {{ $translate('primary_items') }} </strong>
                            </h6>
                            <b-table class="m-3" v-if="is_items_mode" :items="template_primary_items" :fields="fields">
                                <template #head(id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        {{ $translate('no') }}
                                    </h6>
                                </template>
                                <template #head(order_item_type_id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        {{ $translate('type') }}
                                    </h6>
                                </template>
                                <template #cell(id)="{ index }">
                                    <h6>
                                        {{ index + 1 }}
                                    </h6>
                                </template>

                                <template #cell(order_item_type_id)="{ value }">
                                    <h6>
                                        {{ value | filterTypeName(itemTypes) }}
                                    </h6>
                                </template>
                            </b-table>
                        </div>
                        <div class="mt-4" v-if="template_secondary_items.length > 0">
                            <h6 class="text-center mb-2 col-12">
                                <strong>
                                    {{ $translate('secondary_items') }}
                                </strong>
                            </h6>
                            <b-table class="m-3" v-if="is_items_mode" :items="template_secondary_items" :fields="fields">
                                <template #head(id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        {{ $translate('no') }}
                                    </h6>
                                </template>
                                <template #head(order_item_type_id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        {{ $translate('type') }}
                                    </h6>
                                </template>
                                <template #cell(id)="{ index }">
                                    <h6>
                                        {{ index + 1 }}
                                    </h6>
                                </template>

                                <template #cell(order_item_type_id)="{ value }">
                                    <h6>
                                        {{ value | filterTypeName(itemTypes) }}
                                    </h6>
                                </template>
                            </b-table>
                        </div>
                        <show-recent-orders v-if="!is_items_mode && is_recent_import" v-model="selected_order_id"
                            :order_type_id="orderModel.order_type_id" :customer_id="orderModel.customer_id"
                            @set-items="items => setRecentOrderItems(items)" />
                        <select-order-template v-if="!is_items_mode && !is_recent_import"
                            v-model="orderModel.order_template_id" :order_category_id="order_category_id"
                            :orderTemplateId="order_category_id" :include-items="true"
                            :order-type-id="orderModel.order_type_id" @set-items="items => setTemplateItems(items)" />
                    </b-card-body>
                    <b-card-body class="py-0" v-if="orderModel.customer_id">
                        <view-assets v-model="linked_assets" :customer_id="orderModel.customer_id"
                            :customer-assets="customerAssets" :disabled="false" />
                    </b-card-body>
                </b-card>

                <template #modal-footer="{ ok, cancel }">
                    <b-button v-if="is_items_mode" variant="info" @click="clearItems">
                        <b-icon icon="arrow-clockwise"></b-icon>
                    </b-button>

                    <b-button size="fw" variant="info" @click="ok()" v-if="is_items_mode">
                        {{ $translate('import_items') }}
                    </b-button>

                    <b-button size="fw" variant="info" class="btn-fw" @click="cancel()">
                        {{ $cancelLabel() }}
                    </b-button>
                </template>
            </b-modal>
        </b-overlay>

        <template>
            <div>
                <b-row>
                    <b-col class="text-right">
                        <div class="justify-content-end d-flex gap-2 my-2">
                            <b-button @click="showItemModal(true)" size="sm" variant="pink-button"
                                :title="$translate('generate_items_activity')" v-b-tooltip.hover :disabled="!orderModel.customer_id ||
                                    (!isNew && viewMode)
                                    ">
                                <img src="@/assets/images/icon/recent.svg" />
                            </b-button>
                            <b-button @click="showItemModal(false)" variant="pink-button"
                                :title="$translate('generate_items_template')" v-b-tooltip.hover :disabled="!!orderModel.order_template_id ||
                                    (viewMode && !isNew)
                                    ">
                                <img src="@/assets/images/icon/filter-f.svg" />
                            </b-button>

                            <b-button @click="deleteTemplateItems" variant="pink-button" :title="orderModel.order_template_id
                                ? $translate('remove_template_items')
                                : ''
                                " :disabled="!orderModel.order_template_id ||
        (!isNew && viewMode)
        " v-b-tooltip.hover>
                                <img src="@/assets/images/icon/filter.svg" />
                            </b-button>

                            <b-button variant="pink-button" :disabled="!isNew && viewMode" v-if="hasPermissionCreate && !orderModel.completed
                                " @click="setItemView" :title="$translate('add_item')" v-b-tooltip.hover>
                                <img src="@/assets/images/icon/gradient-add.svg" />
                            </b-button>
                            <b-button variant="pink-button" :disabled="(!isNew && viewMode) || !orderItemPrice
                                " v-if="hasPermissionCreate && !orderModel.completed
        " @click="setDiscountView" :title="discountTitle" v-b-tooltip.hover>
                                <img src="@/assets/images/icon/i-1.svg" />
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-alert show v-if="is_secondary">{{ order.type.name }}</b-alert>
            <div v-for="(item, idx) in filteredItemTypeOptions" :key="`primary-items${item.id}`" class="accordion-box">
                <a block href="javascript:void(0)" v-b-toggle="'accordion' + item.id"
                    :class="{ 'active-accordion': accordianModelArray[idx] }" variant="light"
                    class="accordion-header left-sign">
                    <span> {{ item.name }}</span>
                </a>
                <b-collapse :id="'accordion' + item.id" role="tabpanel" v-model="accordianModelArray[idx]">
                    <DisplayOrderItems key="primary-items" :tableIndex="idx + '1'" :filtered-items="listTypeItems(item.id)"
                        :customer-assets="customerAssets" :item-type-id="item.id" :viewMode="viewMode" :isNew="isNew"
                        @toggleAssignment="hideTotals = $event" @view-item="hash => setItemView(hash)"
                        @order-status="getOrderCompletionStatus">
                    </DisplayOrderItems>
                </b-collapse>
            </div>
            <b-alert show v-if="is_secondary">{{
                secondary_order.type.name
            }}</b-alert>
            <div v-for="(item, idx) in secondaryItemTypeOptions" :key="`secondary-items${item.id}`" class="accordion-box">
                <a block href="javascript:void(0)" v-b-toggle="'accordion' + item.id"
                    :class="{ 'active-accordion': accordianModelArray[idx] }" variant="light"
                    class="accordion-header left-sign">
                    <span> {{ item.name }}</span>
                </a>
                <b-collapse :id="'accordion' + item.id" role="tabpanel" v-model="accordianModelArray[idx]">
                    <DisplayOrderItems key="secondary-items" :tableIndex="idx + '2'"
                        :filtered-items="listTypeItems(item.id, true)" :customer-assets="customerAssets"
                        :item-type-id="item.id" :viewMode="true" :isNew="false" @toggleAssignment="hideTotals = $event"
                        @view-item="hash => setItemView(hash, true)" @order-status="getOrderCompletionStatus">
                    </DisplayOrderItems>
                </b-collapse>
            </div>
        </template>

        <view-item ref="viewItem" :order-model="orderModel" :officer="officer" :customer-assets="customerAssets" />

        <ViewDiscount :order-model="orderModel" ref="viewDiscount" />

        <div v-if="hasPricing && (!viewMode || !hideTotals)">
            <b-row class="my-2">
                <b-col cols="9">
                    <b class="float-right">{{ $translate('total') }}</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b>${{ itemsTotals.total | currency }}</b>
                </b-col>
            </b-row>
            <b-row class="my-2">
                <b-col cols="9">
                    <b class="float-right">{{
                        $translate(adjustmentTotals.title)
                    }}</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <span>${{ adjustmentTotals.total | currency }}</span>
                </b-col>
            </b-row>

            <b-row class="my-2">
                <b-col cols="9">
                    <b class="float-right">{{ $translate('total_tax') }}</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <span>${{
                        (itemsTotals.tax + adjustmentTotals.tax) | currency
                    }}</span>
                </b-col>
            </b-row>
            <b-row class="my-2">
                <b-col cols="9">
                    <b class="float-right">{{ $translate('grand_total') }}</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b>${{
                        (itemsTotals.tax +
                            itemsTotals.total +
                            adjustmentTotals.total +
                            adjustmentTotals.tax)
                        | currency
                    }}</b>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import EventBus from '@/exports/event-bus.js'
import DisplayOrderItems from './DisplayOrderItems.vue'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ViewItem from './ViewItem'
import ViewDiscount from './ViewDiscount.vue'
import SelectOrderTemplate from '@/components/SelectOrderTemplate.vue'
import ShowRecentOrders from './ShowRecentOrders.vue'

import ViewAssets from '@/components/ViewAssets'

export default {
    name: 'orders-items',
    components: {
        DisplayOrderItems,
        ViewItem,
        ViewDiscount,
        SelectOrderTemplate,
        ShowRecentOrders,
        ViewAssets,
    },
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            accordianModelArray: [],
            submitting: false,
            hideTotals: false,
            genratedItems: false,
            orderModel: {},
            loading: false,
            linked_assets: [],
            order_category_id: null,
            /////////////////////
            selected_order_id: null,
            is_recent_import: false,
            is_items_mode: false,
            template_primary_items: [],
            template_secondary_items: [],
            visible: [0],
            loadedItemTypes: [],
            orderStatus: 0,
            collapseIndex: null,
            secondary_order: null,
            // customerAssets:[],
        }
    },
    props: {
        viewMode: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
        customerAssets: { type: Array, require: true },
        order: { type: Object, require: true },
    },
    filters: {
        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        displayTypeName(id, types) {
            console.log('types', types)
            return (types.find(x => x.id == id) || {}).name
        },
        filterTypeName(value, types) {
            return (types.find(x => x.id == value) || {}).name
        },
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: '' },
                { key: 'name', label: this.$translate('name') },
                { key: 'order_item_type_id', label: this.$translate('type') },
                { key: 'quantity', label: this.$translate('quantity') },
            ]
        },
        modalTitle() {
            return this.is_items_mode && this.is_recent_import
                ? this.$translate('selected_activity_items')
                : this.is_items_mode
                    ? this.$translate('selected_template_items')
                    : this.is_recent_import
                        ? this.$translate('recent_activities')
                        : this.$translate('activity_template')
        },
        tabOneTitle() {
            return this.is_items_mode
                ? this.$translate('items')
                : this.is_recent_import
                    ? this.$translate('activity')
                    : this.$translate('templates')
        },
        itemTypeOptions() {
            return this.itemTypes.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        filteredItemTypeOptions() {
            const { selectedItemType, onlyUnique } = this

            const list = this.storedItems
                .map(i => i.order_item_type_id)
                .filter(onlyUnique)
                .map(selectedItemType)
                .filter(item => item !== undefined)

            console.log('filteredItemTypeOptions', list)

            return list
        },

        is_secondary() {
            return this.secondaryItemTypeOptions.length > 0
        },

        secondaryItems() {
            return this.$store.state.orderItemStore.secondary_items
        },

        secondaryItemTypeOptions() {
            const { selectedItemType, onlyUnique, secondaryItems } = this

            const list = secondaryItems
                .map(i => i.order_item_type_id)
                .filter(onlyUnique)
                .map(selectedItemType)
                .filter(item => item !== undefined)

            console.log('secondaryItemTypeOptions', list)

            return list
        },
        orderItemPrice() {
            const total = this.itemsTotals.total > 0
            return total
        },
        storedItems() {
            return this.$store.getters['orderItemStore/itemsOnly']
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },
        hasPricing() {
            return this.$store.getters['orderItemStore/hasPricing']
        },

        itemsTotals() {
            return this.$store.getters['orderItemStore/itemsTotals']
        },

        adjustmentTotals() {
            return this.$store.getters['orderItemStore/adjustmentTotals']
        },
        discountTitle() {
            return this.adjustmentItems.length
                ? this.$translate('change_discount')
                : this.$translate('add_discount')
        },

        adjustmentItems() {
            return this.$store.getters['orderItemStore/adjustmentItems']
        },

        officer() {
            return this.$store.state.users.user
        },

        orderItems() {
            return this.$store.state.orders.orderItems
        },
        selectedTemplate() {
            return this.$store.state.orderTemplate.selectedTemplate
        },
    },
    watch: {
        officer: {
            handler: function (_officer, from) {
                console.log('ManageOrderItems watch officer', {
                    _officer,
                    from,
                })
                const { location_section_id } = _officer
                this.$store.dispatch(
                    'masterItem/fetchBySection',
                    location_section_id
                )
            },
            deep: true,
        },
        storedItems: {
            handler: function (items) {
                console.log('stored items', items)
            },
            deep: true,
        },
        orderItems: {
            //load items
            handler: function (items) {
                this.loaditems(items)
            },
            deep: true,
        },

        filteredItemTypeOptions: {
            handler: function (val) {
                this.generateItems(val)
            },
            deep: true,
        },
        'orderModel.order_template_id': {
            handler: function (template_id) {
                EventBus.$emit('update-order-template', template_id)
            },
            deep: true,
        },
        // selectedTemplate: {
        //     handler: function () {
        //         this.importItems()
        //     },
        //     deep: true,
        // },
        order: {
            handler: function (val) {
                console.log('order------------', val)
                const { order_template, secondary_orders } = val
                const { secondary_order_type_id } = order_template || {}
                if (!secondary_order_type_id) return

                //////////////////////////////////////////
                this.getSecondaryOrders(secondary_orders).then(_orders => {
                    console.log('secondary orders---------', _orders)
                    this.secondary_order = _orders.find(
                        x => x.order_type_id == secondary_order_type_id
                    )

                    const { items } = this.secondary_order || {}
                    const secondaryItems = (items || []).map(x => {
                        x.quantity = -x.quantity
                        return x
                    })

                    this.$store.commit(
                        'orderItemStore/SET_SECONDARY_ITEMS',
                        secondaryItems
                    )
                })
            },
            deep: true,
        },
    },
    mounted() {
        const { orderItems } = this
        this.loaditems(orderItems)
        this.loadedItemTypes = this.getLoadedItemTypes(orderItems)
        //Set the visible array. This array controls the visible accordian tabs
        // this.visible =  [...Array(this.loaditems.length)].fill(true)
        console.log('this.storedItems', this.storedItems)
        this.generateItems(this.filteredItemTypeOptions)
        console.log('accordion model', this.accordianModelArray)
    },
    beforeDestroy() {
        EventBus.$off('set-template');
    },
    created() {
        EventBus.$on('set-template', async (value) => {
            this.deleteGenratedTemplate()
            if (value) {
                this.loading = true
                await this.$store.dispatch('orderTemplate/fetchById', value)
                this.$nextTick(() => {
                    this.setimportItems(value)
                    this.orderModel.order_template_id = value
                })

            }
        })
        EventBus.$on('trigger-add-item', () => {
            console.log('ManageOrderItems triggered........')
            this.setItemView()
        })
        EventBus.$on(
            'set-order-model',
            ({
                order: {
                    order_type_id,
                    customer_id,
                    completed,
                    driver_id,
                    delivery_location_section_id,
                    order_template_id,
                },
            }) => {
                this.$nextTick(() => {
                    ///// load officer
                    console.log(
                        'set-order-model-------------------',
                        order_type_id
                    )
                    if (driver_id && this.orderModel.driver_id != driver_id) {
                        this.$store.dispatch('users/fetchUser', driver_id)
                    }

                    this.orderModel = {
                        order_type_id,
                        customer_id,
                        completed,
                        driver_id,
                        delivery_location_section_id,
                        order_template_id,
                    }
                    ///console.log('EventBux Order trigger', this.orderItems)
                    // this.loaditems(this.orderItems, 'EventBus')
                })
            }
        )
    },
    methods: {
        onlyUnique(value, index, array) {
            return array.indexOf(value) === index
        },
        selectedItemType(id) {
            const { itemTypes } = this
            return (itemTypes || []).find(t => t.id == id)
        },
        async getSecondaryOrders(_orders) {
            const { $store } = this
            return await Promise.all(
                _orders.map(x =>
                    $store.dispatch(
                        'orders/fetchByIdDirect',
                        x.secondary_order_id
                    )
                )
            )
        },
        listTypeItems(id, is_secondary) {
            return (
                is_secondary ? this.secondaryItems : this.storedItems
            ).filter(x => x.order_item_type_id == id)
        },
        generateItems(items) {
            this.accordianModelArray.splice(0)
            this.accordianModelArray.push(
                ...[...Array(items.length).keys()].map(() => true)
            )
        },
        loaditems(items) {
            console.log(`loaditems items`, items)
            const cloneItems = []
            for (const item of items) {
                const _item = { ...item }
                const assets = _item.assets.map(i => i.asset_id)
                this.$set(_item, 'assets', assets)
                cloneItems.push(_item)
            }
            this.$store.dispatch('orderItemStore/load', cloneItems)
        },
        clearItems() {
            this.is_items_mode = false
            this.orderModel.order_template_id = null
            this.selected_order_id = null
            this.template_primary_items.splice(0, this.template_primary_items.length)
            this.template_secondary_items.splice(0, this.template_secondary_items.length)
        },
        showItemModal(is_recent_type) {
            this.is_recent_import = !!is_recent_type
            this.clearItems()
            this.$refs['importModal'].show()
        },
        setItemView(hash, is_secondary = false) {
            console.log('item hash', hash)
            const { storedItems, secondaryItems, order, secondary_order } = this

            let item = null
            let order_type_id = null
            let reference_no = null
            let viewMode = true

            if (is_secondary) {
                item = secondaryItems.find(x => x.hash === hash)
                order_type_id = secondary_order.order_type_id
                reference_no = secondary_order.reference_no
            } else {
                item = storedItems.find(x => x.hash === hash)
                reference_no = order.reference_no
                order_type_id = order.order_type_id
                viewMode = this.viewMode
            }

            this.$refs['viewItem'] &&
                this.$refs['viewItem'].showItem(item, {
                    reference_no,
                    viewMode,
                    order_type_id,
                })
        },
        setDiscountView(hash) {
            console.log('item hash', hash)
            const item = this.storedItems.find(x => x.hash === hash)
            this.$refs['viewDiscount'] &&
                this.$refs['viewDiscount'].showItem(item)
        },
        setRecentOrderItems(items) {
            items = items || []
            console.log(
                'template items',
                items.filter(x => !x.is_secondary_order_type)
            )
            this.template_primary_items.splice(0, this.template_primary_items.length)
            this.template_primary_items.push(
                ...items.map(({ master_item, quantity }) => ({
                    ...master_item,
                    quantity,
                }))
            )
            this.is_items_mode = true
        },
        setTemplateItems(items) {
            items = items || []
            console.log('template items:', items)
            this.template_primary_items.splice(0, this.template_primary_items.length)
            this.template_secondary_items.splice(0, this.template_secondary_items.length)

            for (const item of items) {
                const {
                    master_item,
                    default_quantity: quantity,
                    is_secondary_order_type,
                } = item
                if (!is_secondary_order_type) {
                    this.template_primary_items.push({
                        ...master_item,
                        quantity,
                        is_template_item: true,
                    })
                } else {
                    this.template_secondary_items.push({
                        ...master_item,
                        quantity,
                    })
                }
            }

            this.is_items_mode = true
        },
        deleteTemplateItems() {
            for (const item of this.storedItems.filter(
                x => x.is_template_item
            )) {
                this.$store.dispatch('orderItemStore/delete', item.hash)
            }
            this.orderModel.order_template_id = undefined
        },
        async deleteGenratedTemplate() {
            this.template_primary_items.splice(0, this.template_primary_items.length)
            await this.$store.dispatch('orderItemStore/deleteTemplate')
        },
        getLoadedItemTypes(orderItems) {
            const itemTypes = orderItems

            console.log('ORDER ITEM TYPES LOADED: ', itemTypes)
            return itemTypes
        },
        toggleCollapses(ids) {
            ids.forEach(id => {
                this.$root.$emit('bv::toggle::collapse', id)
            })
        },
        getOrderCompletionStatus(value) {
            console.log('^^^^^^^^^^^ Completion Status', value)
        },
        async setimportItems(orderTemplateId) {
            try {
                for (const item of this.selectedTemplate && this.selectedTemplate.items) {
                    const {
                        master_item,
                        order_template_id,
                        default_quantity: quantity,
                        is_secondary_order_type,
                    } = item
                    if (!is_secondary_order_type) {
                        this.template_primary_items.push({
                            ...master_item,
                            order_template_id,
                            quantity,
                            is_template_item: true,
                        })
                    }
                }
                let primaryItems = this.template_primary_items.filter(x => x.order_template_id == orderTemplateId)
                this.genrateItems(primaryItems)
            } catch (error) {
                console.error(error)

            }
        },

        async genrateItems(primaryItems) {
            try {
                const fixItem = item => {
                    item.assets = this.linked_assets
                    item.master_item_id = item.id
                    item.price = item.selling_price
                    item.tax_rate = item.type.tax_rate
                    item.section_from_id = null
                    item.section_to_id = null
                    item.id = null
                }
                for (const item of primaryItems) {
                    fixItem(item)
                    await this.$store.dispatch('orderItemStore/merge', item)
                }
            } catch (error) {
                console.err(error)
            } finally {
                this.loading = false
            }

        },
        async importItems() {
            const fixItem = item => {
                item.assets = this.linked_assets
                item.master_item_id = item.id
                item.price = item.selling_price
                item.tax_rate = item.type.tax_rate
                item.section_from_id = null
                item.section_to_id = null
                item.id = null
            }
            for (const item of this.template_primary_items) {
                fixItem(item)
                console.log('import item', item)
                await this.$store.dispatch('orderItemStore/merge', item)
            }
            this.$refs['importModal'].hide()
        },
    },
    destroyed() {
        EventBus.$off('set-order-model');
    },
}
</script>
<style></style>
